import { FormControl, InputLabel, Select, SelectChangeEvent, SxProps, Theme } from '@mui/material';
import { MenuItem } from 'components/styled/SelectMenuItem';
import { useTranslation } from 'react-i18next';

type SelectMultipleProps<T> = {
  options: T[];
  value: (string | T)[] | undefined;
  onChange: (value: (string | T)[] | undefined) => void;
  getOptionValue: (option: T) => string | number;
  getOptionLabel: (option: T) => string | number;
  variant?: 'filled' | 'standard' | 'outlined' | undefined;
  size?: 'small' | 'medium';
  sx?: SxProps<Theme> | undefined;
  inputLabel?: string;
  enableSelectAll?: boolean;
};

export default function SelectMultiple<T>({
  options,
  value,
  onChange,
  getOptionValue,
  getOptionLabel,
  variant,
  size = 'small',
  sx,
  inputLabel,
  enableSelectAll = true,
}: SelectMultipleProps<T>) {
  const { t } = useTranslation('frontDesk');

  const handleChange = (event: SelectChangeEvent<typeof value>) => {
    const {
      target: { value },
    } = event;

    const statesValue = typeof value === 'string' ? value.split(',') : value;
    const isSelectAllOption =
      (statesValue || [])?.length > 0 && (statesValue || [])[(statesValue || []).length - 1] === '';
    const states = isSelectAllOption ? [] : (statesValue || []).filter(x => x !== '');

    onChange(states);
  };
  return (
    <FormControl size={size} variant={variant} sx={sx}>
      {Boolean(inputLabel) && <InputLabel id="select-multiple">{inputLabel}</InputLabel>}
      <Select
        labelId="select-multiple"
        value={!Boolean(value) || value?.length === 0 ? [''] : value}
        multiple
        onChange={handleChange}
      >
        {enableSelectAll && <MenuItem value={''}>{t('filter.all')}</MenuItem>}
        {(options || []).map((item, index) => (
          <MenuItem key={index} value={getOptionValue(item)}>
            {getOptionLabel(item)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
